var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnotation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7950_8586)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64844 21.6002C3.64844 20.964 4.16421 20.4482 4.80044 20.4482H7.20044C7.83667 20.4482 8.35244 20.964 8.35244 21.6002C8.35244 22.2365 7.83667 22.7522 7.20044 22.7522H4.80044C4.16421 22.7522 3.64844 22.2365 3.64844 21.6002ZM10.8484 21.6002C10.8484 20.964 11.3642 20.4482 12.0004 20.4482H19.2004C19.8367 20.4482 20.3524 20.964 20.3524 21.6002C20.3524 22.2365 19.8367 22.7522 19.2004 22.7522H12.0004C11.3642 22.7522 10.8484 22.2365 10.8484 21.6002Z",
    fill: "#C6CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24219 8.40005C7.24219 7.76381 7.75796 7.24805 8.39419 7.24805H15.5942C16.2304 7.24805 16.7462 7.76381 16.7462 8.40005C16.7462 9.03628 16.2304 9.55205 15.5942 9.55205H8.39419C7.75796 9.55205 7.24219 9.03628 7.24219 8.40005Z",
    fill: "#61739F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9958 7.24805C12.632 7.24805 13.1478 7.76381 13.1478 8.40005V15.6C13.1478 16.2363 12.632 16.752 11.9958 16.752C11.3595 16.752 10.8438 16.2363 10.8438 15.6V8.40005C10.8438 7.76381 11.3595 7.24805 11.9958 7.24805Z",
    fill: "#61739F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64844 2.40005C3.64844 1.76381 4.16421 1.24805 4.80044 1.24805H19.2004C19.8367 1.24805 20.3524 1.76381 20.3524 2.40005C20.3524 3.03628 19.8367 3.55205 19.2004 3.55205H4.80044C4.16421 3.55205 3.64844 3.03628 3.64844 2.40005Z",
    fill: "#C6CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5973 3.64746C22.2335 3.64746 22.7493 4.16323 22.7493 4.79946V7.19946C22.7493 7.83569 22.2335 8.35146 21.5973 8.35146C20.9611 8.35146 20.4453 7.83569 20.4453 7.19946V4.79946C20.4453 4.16323 20.9611 3.64746 21.5973 3.64746ZM21.5973 10.8475C22.2335 10.8475 22.7493 11.3632 22.7493 11.9995V19.1995C22.7493 19.8357 22.2335 20.3515 21.5973 20.3515C20.9611 20.3515 20.4453 19.8357 20.4453 19.1995V11.9995C20.4453 11.3632 20.9611 10.8475 21.5973 10.8475Z",
    fill: "#C6CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39419 3.64746C3.03042 3.64746 3.54619 4.16323 3.54619 4.79946V19.1995C3.54619 19.8357 3.03042 20.3515 2.39419 20.3515C1.75796 20.3515 1.24219 19.8357 1.24219 19.1995V4.79946C1.24219 4.16323 1.75796 3.64746 2.39419 3.64746Z",
    fill: "#C6CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8 2.4C4.8 3.72548 3.72548 4.8 2.4 4.8C1.07452 4.8 0 3.72548 0 2.4C0 1.07452 1.07452 0 2.4 0C3.72548 0 4.8 1.07452 4.8 2.4Z",
    fill: "#61739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8 21.6002C4.8 22.9257 3.72548 24.0002 2.4 24.0002C1.07452 24.0002 0 22.9257 0 21.6002C0 20.2747 1.07452 19.2002 2.4 19.2002C3.72548 19.2002 4.8 20.2747 4.8 21.6002Z",
    fill: "#61739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0031 2.4C24.0031 3.72548 22.9286 4.8 21.6031 4.8C20.2776 4.8 19.2031 3.72548 19.2031 2.4C19.2031 1.07452 20.2776 0 21.6031 0C22.9286 0 24.0031 1.07452 24.0031 2.4Z",
    fill: "#61739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0031 21.6002C24.0031 22.9257 22.9286 24.0002 21.6031 24.0002C20.2776 24.0002 19.2031 22.9257 19.2031 21.6002C19.2031 20.2747 20.2776 19.2002 21.6031 19.2002C22.9286 19.2002 24.0031 20.2747 24.0031 21.6002Z",
    fill: "#61739F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7950_8586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotation);
export default __webpack_public_path__ + "static/media/Annotation.f4d7b96527f6b3963a16c5b7fcd1b946.svg";
export { ForwardRef as ReactComponent };